<script setup>
import { computed } from "vue";

const props = defineProps({
  current: { type: String, required: true }, // 'notary' | 'user'
  showNotary: { type: Boolean, default: true },
  showUser: { type: Boolean, default: true },
});

defineEmits(["switch"]);

const visible = computed(() => props.showNotary && props.showUser);
</script>

<template>
  <div v-if="visible" class="flex flex-col gap-2 w-full">
    <button
      type="button"
      class="view-card"
      :class="{ 'is-active': current === 'notary' }"
      @click="$emit('switch', 'notary')"
    >
      <div class="radio">
        <div v-if="current === 'notary'" class="dot" />
      </div>
      <div class="flex flex-col items-start min-w-0">
        <div class="title">{{ $t("Профиль нотариуса") }}</div>
        <div class="sub">{{ $t("Нотариальные данные") }}</div>
      </div>
    </button>

    <button
      type="button"
      class="view-card"
      :class="{ 'is-active': current === 'user' }"
      @click="$emit('switch', 'user')"
    >
      <div class="radio">
        <div v-if="current === 'user'" class="dot" />
      </div>
      <div class="flex flex-col items-start min-w-0">
        <div class="title">{{ $t("Профиль пользователя") }}</div>
        <div class="sub">{{ $t("Учётная запись") }}</div>
      </div>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.view-card {
  @apply flex items-center gap-3 w-full px-3 py-2.5 rounded-md border border-border bg-card text-left transition-colors cursor-pointer;

  &:hover {
    background-color: hsl(var(--muted) / 0.5);
  }

  &.is-active {
    background-color: hsl(var(--muted));
    border-color: hsl(var(--foreground) / 0.2);
  }
}

.radio {
  @apply w-4 h-4 rounded-full border flex items-center justify-center shrink-0;
  border-color: hsl(var(--border));

  .is-active & {
    border-color: hsl(var(--foreground));
  }
}

.dot {
  @apply w-2 h-2 rounded-full;
  background-color: hsl(var(--foreground));
}

.title {
  @apply text-[13px] font-medium leading-tight;
  color: hsl(var(--foreground));
}

.sub {
  @apply text-[11.5px] mt-0.5;
  color: hsl(var(--muted-foreground));
}
</style>
